import React, { Component } from "react";
import Footer from "../../Components/Footer";
import NavBar from "../../Components/NavBar";

class Privacy extends Component {
  render() {
    return (
      <div>
        <NavBar />
        <div className="container footer-con">
          <h1>Privacy Policy</h1>
          <p>
            <strong>Last updated: Feb 19th, 2025</strong>
          </p>
          <p>
            {" "}
            This privacy policy is for www.bookmytrek.com and governs the
            privacy of its users who choose to use it. The policy sets out the
            different areas where user privacy is concerned and outlines the
            obligations & requirements of the users, the website and website
            owners. Furthermore the way this website processes, stores and
            protects user data and information will also be detailed within this
            policy.
          </p>
          <h4>
            <strong>The Website </strong>
          </h4>
          <p>
            This website and its owners take a proactive approach to user
            privacy and ensure the necessary steps are taken to protect the
            privacy of its users throughout their visiting experience. This
            website comply's to all India's national laws and requirements for
            user privacy.
          </p>
          <h4>
            <strong>Use of Cookies</strong>
          </h4>
          <p>
            This website uses cookies to better the users experience while
            visiting the website. Where applicable this website uses a cookie
            control system allowing the user on their first visit to the website
            to allow or disallow the use of cookies on their computer / device.
            This complies with recent legislation requirements for websites to
            obtain explicit consent from users before leaving behind or reading
            files such as cookies on a user's computer / device. Cookies are
            small files saved to the user's computers hard drive that track,
            save and store information about the user's interactions and usage
            of the website. This allows the website, through its server to
            provide the users with a tailored experience within this website.
            Users are advised that if they wish to deny the use and saving of
            cookies from this website on to their computers hard drive they
            should take necessary steps within their web browsers security
            settings to block all cookies from this website and its external
            serving vendors. This website uses tracking software to monitor its
            visitors to better understand how they use it. This software is
            provided by Google Analytics which uses cookies to track visitor
            usage. The software will save a cookie to your computers hard drive
            in order to track and monitor your engagement and usage of the
            website, but will not store, save or collect personal information.
            You can read Google's privacy policy here for further information [
            http://www.google.com/privacy.html Other cookies may be stored to
            your computers hard drive by external vendors when this website uses
            referral programs, sponsored links or adverts. Such cookies are used
            for conversion and referral tracking and typically expire after 30
            days, though some may take longer. No personal information is
            stored, saved or collected.
          </p>
          <h4>
            <strong>Email Newsletter</strong>
          </h4>
          <p>
            Although this website only looks to include quality, safe and
            relevant external links, users are advised adopt a policy of caution
            before clicking any external web links mentioned throughout this
            website. (External links are clickable text / banner / image links
            to other websites.) The owners of this website cannot guarantee or
            verify the contents of any externally linked website despite their
            best efforts. Users should therefore note they click on external
            links at their own risk and this website and its owners cannot be
            held liable for any damages or implications caused by visiting any
            external links mentioned.
          </p>
          <h4>
            <strong>External Links</strong>
          </h4>
          <p>
            Although this website only looks to include quality, safe and
            relevant external links, users are advised adopt a policy of caution
            before clicking any external web links mentioned throughout this
            website. (External links are clickable text / banner / image links
            to other websites.) The owners of this website cannot guarantee or
            verify the contents of any externally linked website despite their
            best efforts. Users should therefore note they click on external
            links at their own risk and this website and its owners cannot be
            held liable for any damages or implications caused by visiting any
            external links mentioned.{" "}
          </p>
          <h4>
            <strong> Adverts and Sponsored Links</strong>
          </h4>
          <p>
            This website may contain sponsored links and adverts. These will
            typically be served through our advertising partners, to whom may
            have detailed privacy policies relating directly to the adverts they
            serve. Clicking on any such adverts will send you to the advertisers
            website through a referral program which may use cookies and will
            track the number of referrals sent from this website. This may
            include the use of cookies which may in turn be saved on your
            computers hard drive. Users should therefore note they click on
            sponsored external links at their own risk and this website and its
            owners cannot be held liable for any damages or implications caused
            by visiting any external links mentioned.{" "}
          </p>{" "}
          <h4>
            <strong>Social Media Platforms </strong>
          </h4>
          <p>
            Communication, engagement and actions taken through external social
            media platforms that this website and its owners participate on are
            custom to the terms and conditions as well as the privacy policies
            held with each social media platform respectively. Users are advised
            to use social media platforms wisely and communicate / engage upon
            them with due care and caution in regard to their own privacy and
            personal details. This website nor its owners will ever ask for
            personal or sensitive information through social media platforms and
            encourage users wishing to discuss sensitive details to contact them
            through primary communication channels such as by telephone or
            email. This website may use social sharing buttons which help share
            web content directly from web pages to the social media platform in
            question. Users are advised before using such social sharing buttons
            that they do so at their own discretion and note that the social
            media platform may track and save your request to share a web page
            respectively through your social media platform account.{" "}
          </p>
          <h4>
            <strong>Shortened Links in Social Media </strong>
          </h4>
          <p>
            This website and its owners through their social media platform
            accounts may share web links to relevant web pages. By default some
            social media platforms shorten lengthy urls [web addresses] Users
            are advised to take caution and good judgement before clicking any
            shortened urls published on social media platforms by this website
            and its owners. Despite the best efforts to ensure only genuine urls
            are published many social media platforms are prone to spam and
            hacking and therefore this website and its owners cannot be held
            liable for any damages or implications caused by visiting any
            shortened links. Rediscover Paradise Privacy Policy This Privacy and
            Cookies Policy describes how ANHEUSER-BUSCH INBEV SA/NV, a company
            organized and existing under the laws of Belgium, having its
            registered office at Grote Markt 1, 1000 Brussels, Belgium,
            registered with the Register of Legal Entities under company number
            VAT 0417.497.106 RPM Brussels and its Affiliates (“ABI”, “we”, “our”
            or “us”) collect, use, share, and otherwise process personal data
            (defined below) as controller about visitors to our website (the
            “Website”). In this Privacy and Cookie Policy, "personal data" means
            information that (either in isolation or in combination with other
            information held by us) enables you to be identified as an
            individual or recognized directly or indirectly. Overview: To ensure
            that you feel safe and happy visiting and using our Website, the
            following information gives you a comprehensive guide as to what we
            do with your personal data and more specifically how we collect, use
            and pass on your personal data when you use this Website. This
            Privacy and Cookie Policy also describes our use of cookies, how
            your personal data are secured and how you can contact us about our
            privacy practices, including: 1. Data collection: What Information
            We Collect? 2. For which purposes do we use your information and on
            which legal bases? 3. How We Share Your Information 4. How long do
            we retain your personal data? 5. What are your rights? 6. Who can
            you contact in case you have questions or requests? 7. Links to
            Third-Party Sites 8. Do-Not-Track Signals and Similar Mechanisms 9.
            Cookies and similar technologies 9.1 What are cookies and similar
            tracking technologies? 9.2 Strictly Necessary Cookies 9.3
            Performance Cookies 9.4 Targeting Cookies 10. Location Data 11.
            Security 12. Children’s Privacy 13. Changes to this Privacy and
            Cookie Policy Please read this Privacy and Cookie Policy before
            using or submitting any personal data on this Website. By accessing
            and using this Website, you confirm that you have read and that you
            understand the way we collect, process, use and disclose your
            personal data as described herein. Please note that before using or
            submitting personal data on certain sections of this Website, you
            may be asked to confirm electronically your understanding and
            acceptance of this Privacy and Cookie Policy by ticking (a) specific
            box(es). Your affirmative action in ticking that box and/or clicking
            on that button and your use of this Website signify that you
            understand and agree to the collection, processing, use and transfer
            of your personal data as described in this Privacy and Cookie
            Policy.
          </p>
          <strong> 1. DATA COLLECTION: WHAT INFORMATION WE COLLECT?</strong>{" "}
          <p>
            Depending on the purpose of the processing, we need to process the
            following categories of personal data about you: - your personal
            details (first name, last name, where you are from) and your contact
            details (your e-mail address) which you are asked to provide when
            you share your idea with us; - information relating to your idea, in
            writing or in video depending on what you choose to submit on the
            Website; - information about the location of your device, including
            GPS location, when you click on “Activate your geolocation” as
            described in Section 10; - connection and/or browsing data that we
            collect by using cookies and similar tracking technologies as
            described under Section 9. ABI will not collect sensitive personal
            data from you in the context of the Website. Remember that, when we
            ask you to fill in your personal data to allow you to share your
            ideas with us, we will mark certain fields as compulsory, since this
            information is necessary to be able to identify you and to contact
            you in case your idea is selected by us. Please take into account
            that, if you decide not to make such data available to us, you may
            be unable to submit your idea on the Website.
          </p>
          <strong>
            2. FOR WHICH PURPOSES DO WE USE YOUR INFORMATION AND ON WHICH LEGAL
            BASES?
          </strong>
          <p>
            The Website main purpose is to offer information about our projects
            and allow you to share your ideas (all services available on the
            Website are referred to as “the Services”). Depending on the
            Services that you wish to use on the Website, we will process your
            personal data for the following purposes, as justified on the
            following legal bases: To provide the Services, i.e. to collect your
            ideas and to contact you to follow-up on the idea you submitted.
            Your personal data will be processed for the purposes of our
            legitimate interests consisting in collecting your suggestion on how
            ABI can help and identify you and to contact you in case your idea
            is selected by us. For analytic and statistic purposes, i.e., to
            understand the manner in which you interact with our Website and
            thus be capable of introducing improvements in the Website. Your
            personal data will be processed: - based on your consent (following
            the selection of your cookie preferences in our cookie banner – see
            Section 9 below); or - because the processing is necessary for the
            purposes of our legitimate interests consisting in improving the
            user experience. To protect the rights of the services ans others.
            We may use your information as necessary in connection with
            corporate transactions or to protect, enforce or defend the legal
            rights, privacy, safety, or property of the Services, our employees
            or agents, or other users ans to comply with applicable law. Your
            personal data will be processed because the processing is necessary:
            - to comply with a legal obligation to which we are subject (for
            example, to guarantee the security of the personal data we process
            or to respond to authorities’ requests for disclosure of personal
            data, as required by applicable law); or - for the purposes of our
            legitimate interests consisting in safeguarding our rights and our
            property and those of our employees, agents or users or in
            performing corporate transactions. We will only process your
            personal data for specified, explicit and legitimate purposes and we
            will not process your personal data further in a way that goes
            beyond or is incompatible with those purposes. Where required under
            applicable law, we will also collect your express consent to any of
            the above-mentioned activities. You have the right to withdraw any
            given consent at any time (see Section 5).
          </p>
          <strong>4. HOW LONG DO WE RETAIN YOUR PERSONAL DATA?</strong>{" "}
          <p>
            For personal data that we collect and process for the purposes
            outlined in Section 2, we will typically retain such personal data
            for as long as it is necessary to fulfil each of these purposes.
          </p>
          <strong>5. WHAT ARE YOUR RIGHTS?</strong>
          <p>
            Where applicable and under the conditions set forth under applicable
            data protection laws, you may have the following rights concerning
            the processing of your personal data: - Confirmation and
            information. You have the right to receive confirmation of the
            existence of the processing and to obtain information about the
            public or private entities with which ABI has shared your personal
            data. - Access. Subject to certain exceptions, you have the right to
            request information on the data we store concerning you as well as
            the purpose of storage and a copy of the personal data we are
            processing about you, which we will provide to you in electronic
            form. At our discretion we may require you to prove your identity
            before providing the requested information. If you require multiple
            copies of your personal data, we may charge a reasonable
            administration fee. - Rectification. You have the right to require
            that any incomplete or inaccurate personal data that we process
            about you is amended. - Deletion. You have the right to request that
            we delete personal data that we process about you, unless we are
            required to retain such data in order to comply with a legal
            obligation or to establish, exercise or defend legal claims. You may
            also have to right to request the anonymisation, blocking or
            deletion of unnecessary, excessive or non-conforming personal data.
            - Restriction. You have the right to request that we restrict our
            processing of your personal data where: • you believe such data to
            be inaccurate; • our processing is unlawful; or • we no longer need
            to process such data for a particular purpose, but where we are not
            able to delete the data due to a legal or other obligation or
            because you do not want us to delete it. - Portability. You have the
            right to request that we transmit the personal data we hold in
            respect of you to another data controller, where this is: • personal
            information which you have provided to us; and • we are processing
            that data on the basis of your consent or in order to perform our
            obligations under contract to you (such as to provide legal
            services). - Objection. Where the legal justification for our
            processing of your personal data is our legitimate interest, you
            have the right to object to such processing on grounds relating to
            your particular situation. We will abide by your request unless we
            have compelling legitimate grounds for the processing which override
            your interests and rights, or if we need to continue to process the
            data for the establishment, exercise or defence of a legal claim. -
            Withdrawing Consent. If you have consented to our processing of your
            personal data, you have the right to withdraw your consent at any
            time, free of charge - Limitation. You may have the right to limit
            the use or disclosing of your personal data. You can exercise these
            rights by sending a written request to our data protection contact
            (see Section 6). If you are in the EEA, you also have the right to
            lodge a complaint with the local data protection authority if you
            believe that we have not complied with applicable data protection
            laws. Access a list of local data protection authorities in EEA
            countries. If you require further information in relation to your
            privacy rights or would like to exercise any of these rights, please
            also contact our data protection contact point.
          </p>
          <strong>7. LINKS TO THIRD-PARTY SITES</strong>
          <p>
            We are not responsible for the security or privacy of any
            information collected by other websites, applications, or other
            services or by your mobile operating system operator, wireless
            carrier, or other similar providers. You should exercise caution and
            review the privacy statements applicable to the third-party
            websites, applications and services you use.
          </p>
          <strong>8. DO-NOT-TRACK SIGNALS AND SIMILAR MECHANISMS</strong>
          <p>
            Some web browsers may transmit “do-not-track” signals to websites
            with which the user communicates. Because of differences in how web
            browsers incorporate and activate this feature, it is not always
            clear whether users intend for these signals to be transmitted, or
            whether they even are aware of them. Because there currently is no
            industry standard concerning what, if anything, websites should do
            when they receive such signals, the Website and Services currently
            do not take action in response to these signals. If and when a final
            standard is established and accepted, we will reassess how to
            respond to these signals. We will only use cookies and similar
            tracking technologies as detailed in Section 9 below.{" "}
          </p>
          <strong>
            9. COOKIES AND SIMILAR TECHNOLOGIES 9.1 WHAT ARE COOKIES AND SIMILAR
            TRACKING TECHNOLOGIES?
          </strong>
          <p>
            Cookies are small pieces of data being placed on the hard drive of a
            visitor’s device. With the help of cookies you can store information
            for a certain period of time and identify the user’s device. For a
            better user guidance and an individual representation of performance
            we use permanent cookies. We also use so-called session cookies
            which are automatically deleted once you close your browser. You can
            set your browser to inform you of the potential downloading of
            cookies, thus ensuring that the usage of cookies is transparent. The
            Website has in place different types of cookies as explained below.
            For “Strictly Necessary cookies” we are processing your personal
            data for our legitimate purposes explained below. With regards to
            “Performance Cookies”, “Functional Cookies” and “Targeting cookies”,
            we are processing your personal data based on your consent for the
            purposes explained below. Your consent is collected and registered
            following the selection of your cookie preferences in our cookie
            banner. In case you would like to change your cookies preferences,
            please go to “cookie settings” at the end of this Section 9. 9.2
            STRICTLY NECESSARY COOKIES These cookies are necessary for the
            Website to function and cannot be switched off in our systems. They
            are usually only set in response to actions made by you which amount
            to a request for Services, such as setting your privacy preferences,
            logging in or filling in forms. You can set your browser to block or
            alert you about these cookies, but some parts of the site will not
            then work. These cookies do not store any personally identifiable
            information. Cookies used • *** Categories • *** Cookies • *** 9.3
            PERFORMANCE COOKIES These cookies allow us to count visits and
            traffic sources so we can measure and improve the performance of our
            site. They help us to know which pages are the most and least
            popular and see how visitors move around the site. They may be set
            by us or by third party providers whose services we have added to
            our pages. All information these cookies collect is aggregated and
            therefore anonymous. If you do not allow these cookies we will not
            know when you have visited our site and will not be able to monitor
            its performance, and some or all of the services from third party
            providers we have added to our pages may not function properly.
            Cookies used • *** Categories • *** Cookies • *** 9.4 TARGETING
            COOKIES These cookies may be set through our site by our advertising
            partners. They may be used by those companies to build a profile of
            your interests and show you relevant adverts on other sites. They do
            not store directly personal information, but are based on uniquely
            identifying your browser and internet device. If you do not allow
            these cookies, you will experience less targeted advertising.
            Cookies used • *** Categories • *** Cookies • ***
          </p>
          <strong>10. LOCATION DATA</strong>
          <p>
            {" "}
            We may collect and use information about the location of the device
            you are using to help us identify the country where you are located
            and redirect you to the relevant Website for your country. Your
            personal data will be processed based on your consent when you click
            on “Activate your geolocation”. You may be able to adjust the
            settings of your device so that information about your physical
            location is no longer sent to us by (a) disabling location services
            within the device settings; or (b) denying certain websites or
            mobile applications permission to access location information by
            changing the relevant preferences and permissions in your mobile
            device or browser settings. Please note that your location may be
            derived from your WiFi, Bluetooth, and other device settings. See
            your device settings for more information. 11. SECURITY We ensure
            that appropriate technical and organisational security measures are
            taken against unlawful or unauthorised access or use of your
            personal data, as well as against accidental loss or damage to the
            integrity of your personal data. 12. CHILDREN’S PRIVACY Please note
            that our Website is only available for non-professional consumers.
            Do only share the content of our Website with those who are of legal
            drinking age. Our Website and Services are not intended for
            individuals under the legal drinking age. If we learn that an
            individual under the legal drinking age has provided us with
            personal information, we will delete it. 13. CHANGES TO THIS PRIVACY
            AND COOKIE POLICY Except to the extent limited by applicable law,
            ABI may decide at any time − at its discretion − to change, modify,
            and/or add all or parts of this Privacy and Cookie Policy in the
            future. Any change to this Privacy and Cookie Policy will be posted
            on this page and, notified to you by e-mail (where appropriate or
            required by law and to the extent that we have your e-mail address).
            We will indicate at the top of this Privacy and Cookie Policy the
            date on which the Policy was last modified. Where required by law,
            we may also ask you to expressly confirm your consent to the
            modified Privacy and Cookie Policy.
          </p>
          <h4>
            <strong>
              General Booking and Financial Terms Traveller Cancellations,
              Refunds and Complaints
            </strong>
          </h4>
          <p>
            If, as a Traveller, you cancel your requested booking by raising a
            ticket, if the Operator declines your booking request due to non
            availability which will automatically cancel any pre-authorization
            to your credit card and/or refund any nominal amounts charged to
            your credit card in connection with the requested booking within a
            commercially reasonable time (7-10 business days). You agree to pay
            BookMyTrek the Deposit for any booking requested in connection with
            your BookMyTrek Account if such requested bookings are confirmed by
            the Operator. Once your booking is confirmed and you have received
            email acknowledgement, what you have paid is non-refundable. If
            cancellation is made within 31 days to departure 100% of these costs
            will be forfeited. Cancellation of permits will result in the costs
            being 100% forfeited. Neither BookMyTrek nor the Operators selling
            their tours on BookMyTrek .com offer or pay any discounts or refunds
            for missed or unused services which were missed or unused by the
            traveller due to no fault of BookMyTrek , or operators working with
            = "BookMyTrek " | , which shall include any termination of the
            traveller's participation in the tour due to the traveller's own
            fault, negligence or breach of these Terms. All traveller complaints
            about their experience on tour will be passed onto the tour
            operator's team to resolve. BookMyTrek is committed to working with
            tour operators to achieve a high level of service. If the response
            time and/or response quality of the tour operator however continue
            to fall below acceptable timing and quality despite our working
            together to rectify any issues, BookMyTrek reserves the right to
            remove the operators' tour listings from BookMyTrek .com
            Marketplace, Affiliate websites, Mobile Apps and remove any
            Applications provided by us.
          </p>
          <h4>
            <strong>
              Unforeseen Circumstances Operator Cancellations and Refunds
            </strong>
          </h4>
          <p>
            If an Operator cancels a confirmed booking made via the
            Services,BookMyTrek will refund any Payment for such booking to the
            applicable Traveller within a commercially reasonable time of the
            cancellation andthe Traveller may receive an email or other
            communication from BookMyTrek containing alternative Listings and
            other related information. If the Traveller requests a booking from
            one of the alternative Listings this will be treated like a new
            group tour booking. If an Operator cancelled a confirmed booking and
            you, as a Traveller, have not received an email or other
            communication from BookMyTrek , please contact BookMyTrek at
            contact@bookmytrek.com
          </p>
          <h4>
            <strong>Cancellation in the Event of Inclement Weather</strong>
          </h4>
          <p>
            Certain Tours may be weather-dependent. Notwithstanding the
            foregoing, in the event of inclement weather, the Operator has the
            discretion as to whether the weather conditions will prevent the
            Tour from taking place. As an Operator, if you need to cancel an
            Group Tour for reasons of inclement weather, you must contact the
            Traveller and BookMyTrek (at booking@bookmytrek or
            contact@bookmytrek.com as early as possible. Subject to the
            Traveller's consent, the Operator and the Traveller may choose to
            reschedule the Group Tour for another date. If the Group Tour cannot
            be rescheduled, as a Traveller, please contact BookMyTrek so we may
            assist in finding a replacement, non-weather-dependent Group Tour.
            For clarity, in the event the alternative Group Tour is of a higher
            price than the former, you may be responsible for any difference in
            price. In the event the alternative Group Tour is of a lower price,
            you may be entitled to a partial refund for the difference. As a
            Traveller, if you have contacted BookMyTrek as provided above and
            BookMyTrek is unable to find you a replacement Group Tour,
            BookMyTrek may refund the Payment for such booking to the Traveller
            within a commercially reasonable time of the cancellation.
          </p>
        </div>
        <Footer />
      </div>
    );
  }
}
export default Privacy;
